import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaHeart, FaArrowLeft, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

const MembershipPage = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await api.get("/subscription/plans/compare");
        const formattedPlans = response.data.map(plan => {
          const featureList = [];
          if (plan.features) {
            Object.entries(plan.features).forEach(([key, value]) => {
              if (value === true) featureList.push(`Access to ${key}`);
              else if (value === -1) featureList.push(`Unlimited ${key}`);
              else if (typeof value === 'number' && value > 0) featureList.push(`${value} ${key}`);
            });
          }

          return {
            name: plan.displayName || plan.name,
            price: `₹${plan.price?.monthly || 0}`,
            duration: "Monthly",
            features: featureList.length > 0 ? featureList : ["Standard Features"],
            recommended: plan.recommended || plan.popular || false,
          };
        });
        setPlans(formattedPlans);
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  const handleClick = () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm py-4 sticky top-0 z-50">
        <div className="container mx-auto px-6 flex justify-between items-center">
          <Link to="/">
            <span className="text-2xl font-bold flex gap-1">
              <span className="text-gray-900">ST</span>
              <span className="text-pink-500">MATCHZONE</span>
            </span>
          </Link>

          <Link
            to="/"
            className="flex items-center text-gray-600 hover:text-rose-600 font-medium"
          >
            <FaArrowLeft className="mr-2" /> Back to Home
          </Link>
        </div>
      </nav>

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl font-black text-gray-900 mb-4">
            Upgrade to <span className="text-rose-600">Premium</span>
          </h1>
          <p className="text-lg text-gray-600">
            Choose a plan that suits your needs and speed up your partner
            search.
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-rose-500 border-t-transparent"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {plans.map((plan, index) => (
              <div
                key={index}
                className={`bg-white rounded-3xl p-8 border transition-all duration-300 ${
                  plan.recommended
                    ? "border-rose-500 shadow-2xl scale-105 relative z-10"
                    : "border-gray-200 shadow-lg hover:shadow-xl"
                }`}
              >
                {plan.recommended && (
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-rose-600 text-white px-4 py-1 rounded-full text-sm font-bold shadow-lg">
                    Recommended
                  </div>
                )}
                <div className="text-center mb-8">
                  <h3 className="text-xl font-bold text-gray-800 mb-2">
                    {plan.name}
                  </h3>
                  <div className="text-4xl font-black text-gray-900 mb-1">
                    {plan.price}
                  </div>
                  <div className="text-gray-500">{plan.duration}</div>
                </div>
                <ul className="space-y-4 mb-8">
                  {plan.features.map((f, i) => (
                    <li key={i} className="flex items-start text-gray-600">
                      <FaCheck className="text-green-500 mt-1 mr-3 shrink-0" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={handleClick}
                  className={`w-full py-3 rounded-xl font-bold transition-all ${
                    plan.recommended
                      ? "bg-rose-600 text-white hover:bg-rose-700 shadow-lg shadow-rose-500/30"
                      : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                  }`}
                >
                  Choose {plan.name}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MembershipPage;
